import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const LeaveManagement = lazy(() => import("@/pages/LeaveManagement/LeaveManagement"));
const LeaveCalendar = lazy(() => import("@/pages/LeaveManagement/LeaveCalendar"));
const LeaveBalance = lazy(() => import("@/pages/LeaveManagement/LeaveBalance/LeaveBalance"));

const LeaveManagementRoute: RouteConfig = {
    path: "",
    pageName: "Leave Management",
    sidebar: {
        show: true,
        icon: "/assets/media/leaveLogo.svg",
    },
    permission: ["LeaveAdd", "LeaveApprove"],
    children: {
        LEAVE: {
            path: "leaves",
            element: <LeaveManagement />,
            pageName: "My Leaves",
            sidebar: { show: true },
        },
        LEAVE_CALENDAR: {
            path: "leavecalendar",
            element: <LeaveCalendar />,
            pageName: "Leave Calendar",
            sidebar: { show: true },
        },
        LEAVE_BALANCE: {
            path: "leavebalance",
            element: <LeaveBalance />,
            pageName: "Leave Balance",
            sidebar: { show: true },
        }
    }
}
export default LeaveManagementRoute;
    